import { render } from "./AppFooter.vue?vue&type=template&id=4521ee58"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=4521ee58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__